export default "__VITE_ASSET__4fa67a2f__"